var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLimeTick = function SvgLimeTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#92DE63",
    fillRule: "evenodd",
    d: "M27.95 5.285 9.515 23.72l-9.23-9.23 4.65-4.65 4.58 4.58L23.3.636z",
    clipRule: "evenodd"
  })));
};
export { SvgLimeTick as ReactComponent };
export default __webpack_public_path__ + "images/lime-tick.svg";